import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('[ErrorBoundary] Caught error:', error, errorInfo);
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '60vh',
                    gap: 3,
                    p: 4,
                    textAlign: 'center'
                }}>
                    <Box sx={{
                        width: 80,
                        height: 80,
                        borderRadius: '50%',
                        backgroundColor: '#fff3e0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '36px'
                    }}>
                        ⚠
                    </Box>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: 'var(--app-text, #1f2d3d)' }}>
                        Something went wrong
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666', maxWidth: 400 }}>
                        An unexpected error occurred. Please try refreshing the page or click the button below.
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Button
                            variant="contained"
                            startIcon={<RefreshIcon />}
                            onClick={this.handleReset}
                            sx={{
                                backgroundColor: '#27ae86',
                                textTransform: 'none',
                                fontWeight: 600,
                                borderRadius: '12px',
                                px: 3,
                                '&:hover': { backgroundColor: '#1f8f6d' }
                            }}
                        >
                            Try Again
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => window.location.reload()}
                            sx={{
                                color: '#27ae86',
                                borderColor: '#27ae86',
                                textTransform: 'none',
                                fontWeight: 600,
                                borderRadius: '12px',
                                px: 3,
                                '&:hover': { borderColor: '#1f8f6d', backgroundColor: 'rgba(39,174,134,0.05)' }
                            }}
                        >
                            Reload Page
                        </Button>
                    </Box>
                </Box>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
